<template>
  <li class="calendar__event-item section__item site-page-partial"
       :class="calendar.IsRecurring ? 'calendar__event-item--recurring' : ''"
       @click="goToPage(calendar.EventUrl)">
    <article class="site-page-partial__content site-page-partial__content--has-date-field">
      <figure v-if="calendar.ImageHtmlTag" class="site-page-partial__image-container" v-html="calendar.ImageHtmlTag"></figure>
      <div v-if="!calendar.ImageHtmlTag" class="site-page-partial__no-image-container">
        <span class="site-page-partial__no-image-container-graphic"></span>
      </div>
      <div class="site-page-partial__text-container">
        <div class="site-page-partial__date-field">
          <span class="calendar__event-item--date-field-text" v-html="calendarDate"></span>
        </div>
        <ul v-if="!!calendar.CompleteTags?.length" class="site-page-partial__category-list tag-container">
          <li class="site-page-partial__category-item tag tag--small" v-for="(tag) in calendar.CompleteTags">
            {{ tag.TagName }}
          </li>
        </ul>
        <h3 class="site-page-partial__heading heading heading--small">
          <a v-bind:href="calendar.EventUrl" class="site-page-partial__link">
            {{ calendar.Heading }}
          </a>
        </h3>
        <p class="site-page-partial__excerpt" v-html="calendar.MainIntro"></p>
        <div class="site-page-partial__arrow-icon-container">
          <span class="site-page-partial__arrow-icon icon icon--arrow-right"></span>
        </div>
      </div>
    </article>
  </li>
</template>

<script>
export default {
  name: "Calendar",
  props: {
    calendar: {},
    translations: {},
    culture: "",
  },
  methods: {
    goToPage(link) {
      window.location.href = link;
    },

    // For single: Trim ONLY the second line (after <br/>) to N characters + "..."
    truncateSecondLine(html, maxLen = 4) {
      if (!html) return "";
      const parts = html.split(/<br\s*\/?>/i);
      if (parts.length === 1) return html; // no second line

      const line1 = parts[0];
      let line2 = parts.slice(1).join(" ").replace(/&nbsp;/gi, " ").trim();

      // Capitalize the month initial if pattern is "dd m"
      line2 = line2.replace(
          /^(\d{1,2}\s*)([A-Za-zÅÄÖåäöÀ-ÖØ-öø-ÿ])/u,
          (_, d, ch) => d + ch.toUpperCase()
      );

      const short = line2.slice(0, maxLen);
      // basic escaping for < and >
      const esc = short.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return `${line1}<br/>${esc}...`;
    },

    // For recurring: keep line 1, make line 2 = FIRST WORD + "..."
    firstWordSecondLine(html, forceUpper = true, ellipsis = "...") {
      if (!html) return "";
      const parts = html.split(/<br\s*\/?>/i);
      if (parts.length === 1) return html; // no second line

      const line1 = parts[0];
      let line2 = parts.slice(1).join(" ").replace(/&nbsp;/gi, " ").trim();

      // Grab the first word (allowing nordic letters)
      const m = line2.match(/^([A-Za-zÅÄÖåäöÀ-ÖØ-öø-ÿ]+)/u);
      const first = m ? m[1] : (line2.split(/\s+/)[0] || "");
      const out = forceUpper ? first.toUpperCase() : first;

      return `${line1}<br/>${out}${ellipsis}`;
    }
  },

  computed: {
    calendarDate() {
      const startDate = new Date(this.calendar.Start);

      if (this.calendar.DisplayString) {
        if (this.calendar.IsRecurring) {
          return this.firstWordSecondLine(this.calendar.DisplayString, true, "...");
        }
        return this.truncateSecondLine(this.calendar.DisplayString, 4);
      }

      if (this.calendar.IsRecurring) {
        const endDate = new Date(this.calendar.PeriodEndDate);
        const startDayAndMonth = startDate
            .toLocaleDateString(this.culture, { day: "numeric", month: "short" })
            .replaceAll(".", "");
        const startTime = startDate.toLocaleTimeString(this.culture, { hour: "2-digit", minute: "2-digit" });
        const endDayAndMonth = endDate
            .toLocaleDateString(this.culture, { day: "numeric", month: "short" })
            .replaceAll(".", "");
        const timeString = this.translations.SeveralTimes;

        let line1;
        if (startDate.getMonth() === endDate.getMonth()) {
          line1 = `${startDate.getDate()} - ${endDayAndMonth}, ${this.calendar.NumberOfSchedulings > 1 ? timeString : startTime}`;
        } else {
          line1 = `${startDayAndMonth} - ${endDayAndMonth}, ${this.calendar.NumberOfSchedulings > 1 ? timeString : startTime}`;
        }

        return line1;
      }

      const single = startDate.toLocaleDateString(this.culture, {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      return single;
    },
  },
};
</script>


